export default __webpack_public_path__ + "static/media/hamburger.inline.826a558a.svg";